import React from "react";
import styles from "./SaveButton.module.css";
import filledIcon from "../../assets/filled-bookmark.png";
import unfilledIcon from "../../assets/unfilled-bookmark.png";

export default function SaveButton({postId, isSaved, onToggle}) {
 return (
    <button className={styles.button} onClick={onToggle}>
      <img 
         src={isSaved ? filledIcon : unfilledIcon}
         className={styles.icon}
      />
    </button>
 )
}